import React, { useState } from 'react';
import { Box } from '@mui/material';
import GenericLoader from '../../../components/Loader/GenericLoader';
import ManageProjectsComponent from './ManageProjects/ManageProjectComponent';
import { ManageLoaderAttribute } from '../../../constants';
import DynamicTabsComponent from '../../../components/DynamicTabs/DynamicTabsComponent';
const ManageTabs = [
  {
    title: 'Projects',
    index: 0,
    component: <ManageProjectsComponent />,
  },
];

const ManageComponent = (props) => {
  const [loader, setLoader] = React.useState(false);
  const [showError, setShowError] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div>
      {loader ? (
        <div>
          <GenericLoader
            rectAttributes={ManageLoaderAttribute}
            showError={showError}
            setShowError={setShowError}
          />
        </div>
      ) : (
        <Box className="main-content-overlay">
          <div className="main-content-div">
            <DynamicTabsComponent
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              TabsList={ManageTabs}
            />
          </div>
        </Box>
      )}
    </div>
  );
};

export default ManageComponent;
